const DEFAULT_OPTIONS = { year: 'numeric', month: 'long', day: 'numeric' };

const formatDateString = (
  date: Date,
  options: Intl.DateTimeFormatOptions = DEFAULT_OPTIONS
): string => date.toLocaleDateString('en-US', options);

export default formatDateString;
